import React from 'react'

import PropTypes from 'prop-types'

import './style.scss'

export default function Button (props) {
  const {className, buttonType, size, ...buttonProps} = props
  const sizeClass = size ? `btn-${size}` : ''
  const classes = `${className || ''} btn btn-${buttonType} ${sizeClass}`

  return (
    <button className={`Button ${classes}`} {...buttonProps}>
      {props.children}
    </button>
  )
}

Button.defaultProps = {
  buttonType: 'primary',
  size: undefined // avoid adding .btn-lg
}

Button.propTypes = {
  buttonType: PropTypes.oneOf(['primary', 'secondary', 'link', 'inverse', 'primary-inverse', 'danger']),
  onClick: PropTypes.func,
  size: PropTypes.string, // big, small, etc
}



// WEBPACK FOOTER //
// ./src/components/Button/index.js